<script>
  export let number;
  export let label;
</script>

<div class="select-row">
  <div class="label">{label}</div>
  <div class="input-container">
    <input type="number" bind:value={number} step="1" />
  </div>
</div>

<style>
  .select-row {
    margin-bottom: 4px;
  }
  .label {
    width: 100px;
    line-height: 2;
    float: left;
  }
  input {
    display: inline;
    width: 270px;
  }
</style>
